import React, { useEffect, useState } from 'react';
import { Field } from '@alifd/next';
import { Drawer, Input, Form, Radio, Switch, Message } from '@b-design/fusion';
import Button, { FormSubmit, promisifyValidate } from '@/components/Button';
import { getQueryStringArgs } from '@/utils/url-parse';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import './index.less';

const Component = ({ children }) => {
  return (
    <div className="display-flex flex-wrap">
      {React.Children.map(children, (child, _) => {
        return (
          <div
            className="demo-block demo-block-index display-flex flex-column justify-content-flex-end align-start"
            style={{ minWidth: '180px', flex: '1' }}
          >
            {child}
          </div>
        );
      })}
    </div>
  );
};

const CreateDrawer = (props) => {
  const { status, visible, setVisible, data, initData } = props;
  const { spaceId } = getQueryStringArgs();
  const field = Field.useField();
  const [siteLanguage, setSiteLanguage] = useState('en');
  const [zhSiteValue, setZhSiteValue] = useState('');
  const [enSiteValue, setEnSiteValue] = useState('');
  const { init, getValue, setValue, getError, setError } = field;

  const onClose = () => {
    setVisible(false);
    setZhSiteValue('');
    setEnSiteValue('');
    setSiteLanguage('en');
  };

  // 初始化数据
  useEffect(() => {
    if (data && status === 'edit') {
      setZhSiteValue(data.name?.zh_CN);
      setEnSiteValue(data.name?.en_US);
      setValue('name', data.name.en_US);
      setValue('description', data?.description?.en_US || '');
      setValue('status', data.status === 'ENABLE' ? true : false);
    }
    if (status === 'create') {
      setZhSiteValue('');
      setEnSiteValue('');
    }
  }, [visible]);

  const submitFormInfo = async () => {
    const [err, val] = await promisifyValidate(field);
      // 必填英文
      if (!enSiteValue) {
        setError(
          'name',
          $i18n.get({
            id: 'aopf.component.chooseChannelModal.PleaseEnter.enName',
            dm: '请输入英文类目名称',
          }),
        );
      }
      if (err) return;
      const params = {
        name: { en_US: enSiteValue, zh_CN: zhSiteValue ? zhSiteValue : enSiteValue },
        status: val.status === true ? 'ENABLE' : 'DISABLE',
        description: { en_US: val.description, zh_CN: val.description },
        spaceId,
      };
      const editParams = {
        id: data.id,
        name: { en_US: enSiteValue, zh_CN: zhSiteValue ? zhSiteValue : enSiteValue },
        status: val.status === true ? 'ENABLE' : 'DISABLE',
        description: { en_US: val.description, zh_CN: val.description },
      };
      if (enSiteValue) {
        if (status === 'create') {
          const res = await Requests.post('/rest/intercnn/space/category/create', params);
          if (res) {
              Message.success({
                title: $i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Created.successfully',
                  dm: '创建成功',
                }),
              });
              setVisible(false);
              setSiteLanguage('en');
              initData();
            }
        } else {
          const res = await Requests.post('/rest/intercnn/space/category/update', editParams);
          if (res) {
              Message.success({
                title: $i18n.get({
                  id: 'aopf.pages.channel.channelList.message.success',
                  dm: '修改成功',
                }),
              });
              setVisible(false);
              setSiteLanguage('en');
              initData();
            }
        }
      }
  };

  const changeSiteLanguage = (v) => {
    setSiteLanguage(v);
    if (v === 'en') {
      setValue('name', enSiteValue);
    } else {
      setValue('name', zhSiteValue);
    }
  };

  const siteLanguageRadio = (
    <Radio.Group
      shape="button"
      data-shape="button"
      onChange={changeSiteLanguage}
      defaultValue={siteLanguage}
    >
      <Radio id="en" value="en">
        {$i18n.get({
          id: 'aopf.pages.settings.en',
          dm: '英文',
        })}
      </Radio>
      <Radio id="zh" value="zh">
        {$i18n.get({
          id: 'aopf.pages.settings.zh',
          dm: '中文',
        })}
      </Radio>
    </Radio.Group>
  );

  const changeSiteValue = (e) => {
    if (siteLanguage === 'zh') {
      setZhSiteValue(e.target.value);
    } else {
      setEnSiteValue(e.target.value);
    }
  };

  return (
    <Component>
      <Drawer
        title={
          status === 'create'
            ? $i18n.get({ id: 'aopf.pages.miniAppStore.create.category', dm: '新建类目' })
            : $i18n.get({ id: 'aopf.pages.miniAppStore.drawer.edit', dm: '编辑类目' })
        }
        placement="right"
        onClose={onClose}
        visible={visible}
        className="category-create"
      >
        <Form>
          {/* <Form.Item
            name="type"
            label={$i18n.get({
              id: 'aopf.pages.miniAppStore.drawer.categoryChoose',
              dm: '类目选择',
            })}
            required
          >
            <Radio.Group
              shape="button"
              data-shape="container"
              defaultValue="SYSTEM"
              // onChange={changeAppType}
              disabled={status === 'edit'}
            >
              <Radio id="SYSTEM" value="SYSTEM" data-ctype="icon-text">
                {$i18n.get({
                  id: 'aopf.pages.miniAppStore.select.systematicCategory',
                  dm: '系统类目',
                })}
              </Radio>
              <Radio id="OPERATION" value="OPERATION" data-ctype="icon-text">
                {$i18n.get({
                  id: 'aopf.pages.miniAppStore.select.operationCategory',
                  dm: '运营类目',
                })}
              </Radio>
            </Radio.Group>
            <p className="form-create-err-msg-p">{getError('type')}</p>
          </Form.Item> */}
          <Form.Item
            name="name"
            label={$i18n.get({
              id: 'aopf.pages.miniAppStore.drawer.categoryName',
              dm: '类目名称',
            })}
          >
            <>
              <Input
                addonBefore={siteLanguageRadio}
                onBlur={changeSiteValue}
                maxLength={40}
                style={{ width: '400px' }}
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniAppStore.drawer.categoryName.des',
                  dm: '请输入类目名称，不超过40个字符',
                })}
                {...init('name', {
                  initValue: '',
                  rules: {
                    maxLength: 40,
                    required: siteLanguage === 'en',
                    message: $i18n.get({
                      id: 'aopf.pages.miniAppStore.drawer.categoryName.des',
                      dm: '请输入类目名称，不超过40个字符',
                    }),
                  },
                })}
              />
              <p className="form-create-err-msg-p">{getError('name')}</p>
            </>
          </Form.Item>

          <Form.Item
            name="description"
            label={$i18n.get({
              id: 'aopf.pages.miniAppStore.drawer.categoryDes',
              dm: '类目描述',
            })}
          >
            <Input.TextArea
              placeholder={$i18n.get({
                id: 'aopf.pages.miniAppStore.drawer.categoryDes.des',
                dm: '不超过200个字符',
              })}
              autoHeight={{ minRows: 4, maxRows: 8 }}
              style={{ width: '400px' }}
              {...init('description', {
                initValue: '',
                rules: {
                  // minLength: 2,
                  maxLength: 200,
                  message: $i18n.get({
                    id: 'aopf.pages.miniAppStore.drawer.categoryDes.des',
                    dm: '不超过200个字符',
                  }),
                },
              })}
              showLimitHint
              maxLength={200}
            />
          </Form.Item>
          <Form.Item
            name="status"
            label={$i18n.get({
              id: 'aopf.pages.miniAppStore.drawer.categoryStatus',
              dm: '状态开关',
            })}
            required
          >
            <Switch
              autoWidth
              checkedChildren={$i18n.get({
                id: 'aopf.pages.miniAppStore.drawer.categoryStatus.visible',
                dm: '可见',
              })}
              unCheckedChildren={$i18n.get({
                id: 'aopf.pages.miniAppStore.drawer.categoryStatus.invisible',
                dm: '不可见',
              })}
              {...init('status', {
                initValue: false,
                valueName: 'checked',
                rules: {
                  required: true,
                  // message: $i18n.get({
                  //   id: 'aopf.pages.miniAppStore.drawer.categoryDes.des',
                  //   dm: '不超过200个字符',
                  // }),
                },
              })}
            />
            <p className="form-create-err-msg-p">{getError('status')}</p>
          </Form.Item>
          <Form.Item name="agree">
            <div className="create-submit">
              <FormSubmit
                type="primary"
                onClick={submitFormInfo}
                validate
                style={{
                  height: 40,
                  fontWeight: 500,
                  fontSize: 16,
                  color: '#fff',
                  letterSpacing: '0.15px'
                }}
              >
                {$i18n.get({ id: 'aopf.pages.miniapp.detail.btn.ok', dm: '确认' })}
              </FormSubmit>
              <Button
                type="secondary"
                style={{
                  height: 40,
                  fontWeight: 500,
                  fontSize: 16,
                  letterSpacing: '0.15px',
                  marginLeft: 16,
                }}
                onClick={onClose}
              >
                {$i18n.get({ id: 'aopf.pages.miniapp.detail.btn.cancel', dm: '取消' })}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Drawer>
    </Component>
  );
};

export default CreateDrawer;
